// helpers.js

// Function to convert UTC datetime to local datetime for input[type=datetime-local]
export const convertUTCToLocalTime = (utcDateTime) => {
    const dateTime = new Date(utcDateTime);
    const localDate = new Date(dateTime.getTime() - dateTime.getTimezoneOffset() * 60000);
    return localDate.toISOString().slice(0, 16);
};
// Function to convert local datetime to UTC datetime 
export const convertLocalTimeToUTC = (localDateTime) => {
    const localTimeDate = new Date(localDateTime);
    return localTimeDate.toISOString();
};

// Format a number with commas and no decimal places
export const formatNumber = (number) => {
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(number);
  };
  
  // Format an ordinal number (1st, 2nd, 3rd, etc.)
  export const formatOrdinal = (n) => {
    const s = ["th", "st", "nd", "rd"],
          v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };
  
  // Get the sort indicator arrow for a column
  export const getSortIndicator = (sortConfig, key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'ascending' ? '▲' : '▼';
    }
    return '';
  };
  
  // Request a sort operation on a column
  export const requestSort = (sortConfig, setSortConfig, key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };
  